import React from 'react';
import { XCircleIcon } from 'lucide-react';
const problems = ['Passi ore ogni settimana a pianificare le lezioni da zero', 'Finisci le idee e ripeti sempre gli stessi esercizi', 'Non sai come strutturare una progressione logica per tutto l’anno', 'La burocrazia delle valutazioni e dei report ti toglie tempo prezioso', 'Ti senti impreparato o stressato prima di entrare in palestra'];
export function ProblemSection() {
  return <section className="bg-[#0A0A0A] px-5 py-16" data-id="element-179" data-mp="39g2sn3obh8yx">
      <div className="mx-auto max-w-4xl text-center" data-id="element-180" data-mp="35gu0g38xdj5h">
        <p className="text-xs font-bold uppercase tracking-[.2em] text-emerald-300" data-id="element-181" data-mp="35idfxrmrbq67">
          La realtà dell’insegnamento
        </p>
        <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-182" data-mp="3eh8np85g98bm">
          Insegni Scienze Motorie? Questi problemi ti suonano familiari?
        </h2>
        <div className="mt-10 grid gap-3 text-left sm:grid-cols-2" data-id="element-183" data-mp="1k37naiu94d9f">
          {problems.map(problem => <div key={problem} className="flex gap-3 border border-white/10 bg-[#16161F] p-4" data-id="element-184" data-mp="jdn5w5thx25z">
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" data-id="element-185" data-mp="ocq00v7xtnz6" />
              <p className="text-sm font-semibold leading-snug text-white" data-id="element-186" data-mp="scqq5d4efnm2">
                {problem}
              </p>
            </div>)}
        </div>
        <p className="mt-10 font-display text-3xl font-bold uppercase leading-none text-emerald-300 sm:text-4xl" data-id="element-187" data-mp="123lecn17gxa5">
          Per quanto ancora vuoi continuare a improvvisare?
        </p>
      </div>
    </section>;
}